import builder from '../builder';
import Pencil from '../../streamline-icons/light/pencil-1.svg';

export default builder('IconPencilLight', Pencil);
